import type { Cache, UpdateResolver } from "@urql/exchange-graphcache";

type MutationUpdates = Record<string, UpdateResolver>;

/** Drop every cached `auditEvents` query so the log refetches. */
export function invalidateAuditEvents(cache: Cache): void {
  for (const field of cache.inspectFields("Query")) {
    if (field.fieldName === "auditEvents") {
      cache.invalidate("Query", field.fieldName, field.arguments);
    }
  }
}

/**
 * Every mutation may leave an audit entry (pim-graphql-server records support
 * actions), and graphcache cannot know which cached `auditEvents` list it
 * belongs to — so after any mutation the audit queries are invalidated, on top
 * of the generated list updaters.
 */
export function withAuditInvalidation(
  mutationNames: readonly string[],
  updates: Partial<MutationUpdates>,
): MutationUpdates {
  return Object.fromEntries(
    mutationNames.map((name) => {
      const updater = updates[name];
      const resolver: UpdateResolver = (result, args, cache, info) => {
        updater?.(result, args, cache, info);
        invalidateAuditEvents(cache);
      };
      return [name, resolver];
    }),
  );
}
